import React from 'react';

function Contact({ siteData }) {
  if (!siteData) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        <p>Yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8 text-toyota-red">İletişim</h1>
        
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* İletişim Bilgileri */}
            <div className="bg-white rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-bold mb-6 text-gray-800">İletişim Bilgileri</h2>
              
              {siteData && siteData.contact && (
                <div className="space-y-4">
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-toyota-red rounded-full flex items-center justify-center mr-4">
                      <span className="text-white text-sm">📞</span>
                    </div>
                    <div>
                      <p className="font-semibold">Telefon</p>
                      <p className="text-gray-600">{siteData.contact.phone}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-toyota-red rounded-full flex items-center justify-center mr-4">
                      <span className="text-white text-sm">✉️</span>
                    </div>
                    <div>
                      <p className="font-semibold">E-posta</p>
                      <p className="text-gray-600">{siteData.contact.email}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-toyota-red rounded-full flex items-center justify-center mr-4">
                      <span className="text-white text-sm">📍</span>
                    </div>
                    <div>
                      <p className="font-semibold">Adres</p>
                      <p className="text-gray-600">{siteData.contact.address}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-toyota-red rounded-full flex items-center justify-center mr-4">
                      <span className="text-white text-sm">🕒</span>
                    </div>
                    <div>
                      <p className="font-semibold">Çalışma Saatleri</p>
                      <p className="text-gray-600">{siteData.contact.workingHours}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* İletişim Formu */}
            <div className="bg-white rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-bold mb-6 text-gray-800">Bize Ulaşın</h2>
              
              <form className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                    Ad Soyad
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toyota-red"
                    placeholder="Adınız ve soyadınız"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    E-posta
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toyota-red"
                    placeholder="E-posta adresiniz"
                  />
                </div>
                
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                    Telefon
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toyota-red"
                    placeholder="Telefon numaranız"
                  />
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                    Mesaj
                  </label>
                  <textarea
                    id="message"
                    rows="4"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toyota-red"
                    placeholder="Mesajınızı yazın..."
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-toyota-red text-white py-3 px-6 rounded-md font-semibold hover:bg-red-700 transition-colors"
                >
                  Mesaj Gönder
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
